import MentoringPrograms from './MentoringPrograms.vue';

export default MentoringPrograms;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/programs/index.ts